/** @format */

import {
	Directive,
	ElementRef,
	Inject,
	OnDestroy,
	OnInit,
	PLATFORM_ID,
	Renderer2,
	input,
	output
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
	selector: '[clickDetectionHandler]'
})
export class ClickDetectionHandlerDirective implements OnInit, OnDestroy {
	readonly shouldEmitClickOutside = input((hasElement) => hasElement);
	readonly isClickedOutside = output<boolean>();

	constructor(
		private element: ElementRef<HTMLElement>,
		@Inject(PLATFORM_ID) private platformId,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.handleClickEvent();
		}
	}

	ngOnDestroy(): void {
		if (this.unListener) {
			this.unListener();
		}
	}

	private handleClickEvent(): void {
		this.unListener = this.renderer.listen('window', 'click', ({ target }: Event) => {
			// Only run when review-dropdown-select is not clicked.
			// We need to know if there is a click outside the content to close it and avoid a lot of dropdowns remaining opened.
			const dropdownElement = this.element.nativeElement;
			const hasElement = !!dropdownElement && !dropdownElement.contains(target as Node);

			const shouldEmit = this.shouldEmitClickOutside()(hasElement);
			this.isClickedOutside.emit(shouldEmit);
		});
	}

	private unListener: () => void;
}
